import { TIllustrationProps } from '@/common/components/Illustrations/types';
import { Svg, G, Path } from 'react-native-svg';

export const LogoMastercard = ({
  width = 53,
  height = 33,
  className,
}: TIllustrationProps) => {
  return (
    <Svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 53 33"
      fill="none"
    >
      <G>
        <Path
          d="M33.6144 4.19019L19.5305 4.19019L19.5305 29.4352L33.6144 29.4352L33.6144 4.19019Z"
          fill="#FF5F00"
        />
        <Path
          d="M20.4197 16.8109C20.4197 11.6914 22.8252 7.1294 26.5675 4.19062C23.8312 2.04116 20.375 0.756836 16.6193 0.756836C7.73081 0.756836 0.523438 7.94548 0.523438 16.8109C0.523438 25.6763 7.73081 32.8649 16.6193 32.8649C20.375 32.8649 23.8267 31.5806 26.5675 29.4312C22.8252 26.4924 20.4197 21.9303 20.4197 16.8109Z"
          fill="#EB001B"
        />
        <Path
          d="M52.6092 16.8109C52.6092 25.6763 45.4018 32.8649 36.5133 32.8649C32.7576 32.8649 29.306 31.5806 26.5652 29.4312C30.3075 26.4924 32.7129 21.9303 32.7129 16.8109C32.7129 11.6914 30.3075 7.1294 26.5652 4.19062C29.3015 2.04116 32.7576 0.756836 36.5133 0.756836C45.4018 0.756836 52.6092 7.94548 52.6092 16.8109Z"
          fill="#F79E1B"
        />
      </G>
    </Svg>
  );
};
